import { render, staticRenderFns } from "./announcement.vue?vue&type=template&id=1422622a&scoped=true"
import script from "./announcement.vue?vue&type=script&lang=js"
export * from "./announcement.vue?vue&type=script&lang=js"
import style0 from "./announcement.vue?vue&type=style&index=0&id=1422622a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1422622a",
  null
  
)

export default component.exports